/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiWorklistAllRequestPost } from '../fn/worklist/api-worklist-all-request-post';
import { ApiWorklistAllRequestPost$Params } from '../fn/worklist/api-worklist-all-request-post';
import { apiWorklistDeleteRequestPost } from '../fn/worklist/api-worklist-delete-request-post';
import { ApiWorklistDeleteRequestPost$Params } from '../fn/worklist/api-worklist-delete-request-post';
import { apiWorklistMyRequestPost } from '../fn/worklist/api-worklist-my-request-post';
import { ApiWorklistMyRequestPost$Params } from '../fn/worklist/api-worklist-my-request-post';
import { apiWorklistTestAaaGet } from '../fn/worklist/api-worklist-test-aaa-get';
import { ApiWorklistTestAaaGet$Params } from '../fn/worklist/api-worklist-test-aaa-get';
import { BooleanApiRespModel } from '../models/boolean-api-resp-model';
import { CourseWorklist } from '../models/course-worklist';
import { CourseWorklistPagedResult } from '../models/course-worklist-paged-result';

@Injectable({ providedIn: 'root' })
export class WorklistService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiWorklistMyRequestPost()` */
  static readonly ApiWorklistMyRequestPostPath = '/api/Worklist/MyRequest';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWorklistMyRequestPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiWorklistMyRequestPost$Response(params?: ApiWorklistMyRequestPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CourseWorklist>>> {
    return apiWorklistMyRequestPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiWorklistMyRequestPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiWorklistMyRequestPost(params?: ApiWorklistMyRequestPost$Params, context?: HttpContext): Observable<Array<CourseWorklist>> {
    return this.apiWorklistMyRequestPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CourseWorklist>>): Array<CourseWorklist> => r.body)
    );
  }

  /** Path part for operation `apiWorklistAllRequestPost()` */
  static readonly ApiWorklistAllRequestPostPath = '/api/Worklist/AllRequest';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWorklistAllRequestPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiWorklistAllRequestPost$Response(params?: ApiWorklistAllRequestPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CourseWorklistPagedResult>> {
    return apiWorklistAllRequestPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiWorklistAllRequestPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiWorklistAllRequestPost(params?: ApiWorklistAllRequestPost$Params, context?: HttpContext): Observable<CourseWorklistPagedResult> {
    return this.apiWorklistAllRequestPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CourseWorklistPagedResult>): CourseWorklistPagedResult => r.body)
    );
  }

  /** Path part for operation `apiWorklistTestAaaGet()` */
  static readonly ApiWorklistTestAaaGetPath = '/api/Worklist/TestAAA';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWorklistTestAaaGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWorklistTestAaaGet$Response(params?: ApiWorklistTestAaaGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiWorklistTestAaaGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiWorklistTestAaaGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWorklistTestAaaGet(params?: ApiWorklistTestAaaGet$Params, context?: HttpContext): Observable<void> {
    return this.apiWorklistTestAaaGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiWorklistDeleteRequestPost()` */
  static readonly ApiWorklistDeleteRequestPostPath = '/api/Worklist/DeleteRequest';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWorklistDeleteRequestPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiWorklistDeleteRequestPost$Response(params?: ApiWorklistDeleteRequestPost$Params, context?: HttpContext): Observable<StrictHttpResponse<BooleanApiRespModel>> {
    return apiWorklistDeleteRequestPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiWorklistDeleteRequestPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiWorklistDeleteRequestPost(params?: ApiWorklistDeleteRequestPost$Params, context?: HttpContext): Observable<BooleanApiRespModel> {
    return this.apiWorklistDeleteRequestPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<BooleanApiRespModel>): BooleanApiRespModel => r.body)
    );
  }

}
